var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinpoinLocationMonitoringSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M352 200C352 283.947 283.947 352 200 352C116.053 352 48 283.947 48 200C48 116.053 116.053 48 200 48C283.947 48 352 116.053 352 200Z",
    fill: "#3699FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M281.902 200C281.902 188.941 279.696 178.334 275.677 168.643L252.677 178.181C246.899 164.248 235.754 153.103 221.821 147.325L231.359 124.324C221.667 120.306 211.061 118.1 200.002 118.1C188.943 118.1 178.336 120.306 168.645 124.324L178.183 147.325C164.25 153.103 153.105 164.248 147.327 178.181L124.326 168.643C120.307 178.334 118.102 188.941 118.102 200C118.102 211.059 120.307 221.666 124.326 231.357L147.327 221.819C153.105 235.752 164.25 246.897 178.183 252.675L168.645 275.676C178.336 279.694 188.943 281.9 200.002 281.9C211.061 281.9 221.667 279.694 231.359 275.676L221.821 252.675C235.754 246.897 246.899 235.752 252.677 221.819L275.677 231.357C279.696 221.666 281.902 211.059 281.902 200Z",
    fill: "#3699FF",
    stroke: "white",
    strokeWidth: 49.8,
    strokeDasharray: "99.6 99.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinpoinLocationMonitoringSvg);
export default __webpack_public_path__ + "static/media/pinpoinLocationMonitoringSvg.730ae86eebccc47290a28897aeb7594f.svg";
export { ForwardRef as ReactComponent };